import apiClient from './config';
import { API_ENDPOINTS } from '../config/api';

export const getPlantillas = () => apiClient.get(API_ENDPOINTS.TEMPLATE.LIST);
export const getPlantilla = (id) => apiClient.get(API_ENDPOINTS.TEMPLATE.DETAIL(id));
export const createPlantilla = (data) => apiClient.post(API_ENDPOINTS.TEMPLATE.CREATE, data);
export const updatePlantilla = (id, data) => apiClient.put(API_ENDPOINTS.TEMPLATE.UPDATE(id), data);
export const deletePlantilla = (id) => apiClient.delete(API_ENDPOINTS.TEMPLATE.DELETE(id));
export const createPlantillaOftalmologica = () => apiClient.post(API_ENDPOINTS.TEMPLATE.CREATE_OPHTHALMOLOGIC);